// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.calc-input {
    border-radius: 10px;
    padding: 0 10px;
    transition: 0.25s ease-in-out;
    height: 48px;
    cursor: pointer;
    font-weight: 400;
    font-size: 16px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: black;
    border: none;
    outline: none;
    margin: 0;
    padding-right: 32px;
}

input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
}

input[type="number"] {
    -moz-appearance: textfield; /* для Firefox */
}


.calc-input::placeholder {
    color: rgba(0, 0, 0, 0.5);
}

.primary-input {
    background: #f7f7f7;
}

.primary-input:hover, .primary-input:focus {
    background: #d9d9d9;
}

.transparent-input {
    background: transparent;
}

.transparent-input:hover, .transparent-input:focus {
    background: #f7f7f7;
}

.outlined-input {
    border: 2px solid #d9d9d9;
    background: transparent;
}

.outlined-input:hover, .outlined-input:focus {
    background: #f7f7f7;
}`, "",{"version":3,"sources":["webpack://./src/components/ui/input/style.css"],"names":[],"mappings":"AAAA;IACI,mBAAmB;IACnB,eAAe;IACf,6BAA6B;IAC7B,YAAY;IACZ,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,YAAY;IACZ,YAAY;IACZ,aAAa;IACb,SAAS;IACT,mBAAmB;AACvB;;AAEA;;IAEI,wBAAwB;IACxB,SAAS;AACb;;AAEA;IACI,0BAA0B,EAAE,gBAAgB;AAChD;;;AAGA;IACI,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,yBAAyB;IACzB,uBAAuB;AAC3B;;AAEA;IACI,mBAAmB;AACvB","sourcesContent":[".calc-input {\n    border-radius: 10px;\n    padding: 0 10px;\n    transition: 0.25s ease-in-out;\n    height: 48px;\n    cursor: pointer;\n    font-weight: 400;\n    font-size: 16px;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    color: black;\n    border: none;\n    outline: none;\n    margin: 0;\n    padding-right: 32px;\n}\n\ninput[type=\"number\"]::-webkit-inner-spin-button,\ninput[type=\"number\"]::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n}\n\ninput[type=\"number\"] {\n    -moz-appearance: textfield; /* для Firefox */\n}\n\n\n.calc-input::placeholder {\n    color: rgba(0, 0, 0, 0.5);\n}\n\n.primary-input {\n    background: #f7f7f7;\n}\n\n.primary-input:hover, .primary-input:focus {\n    background: #d9d9d9;\n}\n\n.transparent-input {\n    background: transparent;\n}\n\n.transparent-input:hover, .transparent-input:focus {\n    background: #f7f7f7;\n}\n\n.outlined-input {\n    border: 2px solid #d9d9d9;\n    background: transparent;\n}\n\n.outlined-input:hover, .outlined-input:focus {\n    background: #f7f7f7;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
